define('lq/services/mpa/pullDownEvents',[
    'lq/pullDownAction'
], function (pullDownAction) {
    'use strict';

    function PullDownEvents() {
    };

    PullDownEvents.typeName = 'PullDownEvents';

    PullDownEvents.prototype.initialize = function () {
        if (window !== window.parent) return;

        var action = this.rootDrop;
        pullDownAction.attach(this.piping.$app, this.piping.$actionWrapper, function () {
            if (action.isEventEnabled('pullDown')) {
                action.triggerEventIfEnabled('pullDown');
            } else {
                window.location.reload();
            }
        });
    };

    return PullDownEvents;
});
